import useFilterParams from "@/hooks/useFilterParams";
import { getMentionViewDateRanges } from "@/views/MentionsView/MentionLayout/ranges";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";
import { formatDateForApi } from "@/utils";

export default function EmptyTimePeriod({
  searchStartDate,
}: {
  searchStartDate?: string;
}) {
  const [{ tag }, setFilters] = useFilterParams();

  const allResultsDateRange = getMentionViewDateRanges(searchStartDate).find(
    (range) => range.identifier === "all_results"
  );

  return (
    <Empty data-testid="empty-period-no-mentions">
      <EmptyHeader>
        <EmptyMedia></EmptyMedia>
        <EmptyTitle>
          <Trans>Inga omnämnanden</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Det finns inga träffar under vald period.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      {allResultsDateRange && (
        <EmptyContent>
          <Button
            variant="outline"
            onClick={(e: unknown) => {
              (e as MouseEvent).preventDefault();

              setFilters(
                {
                  tag,
                  start_date: formatDateForApi(allResultsDateRange.startDate),
                  end_date: formatDateForApi(allResultsDateRange.endDate),
                },
                true
              );
            }}
          >
            <Trans>Visa alla</Trans>
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
}
